import React, { Fragment } from 'react';
import { bool } from 'prop-types';
import { styWrapper, styBankAccount, styPhysicalAddress } from './styles';

// Direct image URLs
const BRI_LOGO_URL = 'https://upload.wikimedia.org/wikipedia/commons/9/97/Logo_BRI.png';
const BCA_LOGO_URL = 'https://jasalogocepat.com/wp-content/uploads/2023/09/Logo-Bank-BCA-PNG-Transparan-jasalogocepat-1536x502.png';
const BITCOIN_LOGO_URL = 'https://www.freeiconspng.com/uploads/bitcoin-logo-transparent-png-13.png';

function FooterSection({ isInvitation }) {
  return (
    <Fragment>
      <footer id="fh5co-footer" role="contentinfo" css={styWrapper}>
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="main-font">Gift</h2>
              <p>Your presence is our greatest gift. However, if you wish to honor us with a gift, we've provided the following options:</p>
            </div>
          </div>
                 
          {/* BCA Accounts */}
          <div className="row" css={styBankAccount}>
            <div className="col-md-6 text-center">
              <div className="bank-item">
                <div className="bank-logo">
                  <img src={BCA_LOGO_URL} alt="BCA Logo" />
                </div>
                <div className="bank-content">
                  <h3>Yayuk Fadilah</h3>
                  <p className="account-number">3660369057</p>
                </div>
              </div>
            </div>
           
          </div>
          
          <div className="row copyright">
            <div className="col-md-12 text-center">
              <p>
                <small className="block">&copy; 2025 Created by Bayu with love.</small>
                <small className="block">
                  Song by{' '}
                  <a href="https://www.youtube.com/watch?v=R1zjcsKfZAg" target="_blank" rel="noreferrer">
                    Rony Parulian - Tak Ada Ujungnya (Official Music Video)
                  </a>
                </small>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </Fragment>
  );
}

FooterSection.propTypes = {
  isInvitation: bool.isRequired,
};

export default React.memo(FooterSection);
